import React from 'react';
import './style.scss';
import { useParams } from 'react-router-dom';
import ViewImageComponent from '../ViewImageComponent';

interface IProfileLabelAndTitle {
  content: any;
  attribute: any;
  label: any;
  marginBottom?: string;
}

const ProfileLabelAndTitle = ({
  content,
  attribute,
  label,
  marginBottom,
}: IProfileLabelAndTitle) => {
  const { customerId } = useParams<{ customerId: string }>();

  const renderContent = (ele, content) => {
    const value = content?.[ele];

    if (
      ele
      && typeof content?.[ele] === 'object' && value?.docKey
    ) {
      return (
        <ViewImageComponent
          pageName="document"
          name={`Lease Agreement.${value?.extention}`}
          payload={value}
          imageType={value?.fileType}
          docType={value?.fileType}
          fileExt={value?.extention}
          hideActions
          merchantId={customerId}
        />
      );
    }
    return <>{value}</>;
  };

  return (
    <div className="content-card">
      <div className="content-card-wrapper">
        {attribute?.map((ele, i) => (
          <div key={i} className={ele ? 'content-card-cover' : 'empty-content-card-cover'} style={{ marginBottom }}>
            <div className="card-label">
              {' '}
              {label?.[ele]}
            </div>
            <div className={`card-title ${ele}`}>{renderContent(ele, content)}</div>
          </div>
        ))}
      </div>
      <div className="bottom-border" />
    </div>
  );
};

export default ProfileLabelAndTitle;
